const publications = [
  {
    issueID: '2/2019',
    thumbnailSource: 'collections/issues/2019/parts-cover/tinified/1-jas-2019-2-tobias_biancone_Page_1.png',
    authorName: 'Tobias Biancone',
    articleTitle: 'Editorial',
    filePath: 'collections/issues/2019/parts/1-jas-2019-2-tobias_biancone.pdf'
  },
  {
    issueID: '2/2019',
    thumbnailSource: 'collections/issues/2019/parts-cover/tinified/2-jas-2019-2-george_banu_Page_1.png',
    authorName: 'George Banu',
    articleTitle: 'Regii shakespearieni și cărțile lui Kiefer',
    filePath: 'collections/issues/2019/parts/2-jas-2019-2-george_banu.pdf'
  },
  {
    issueID: '2/2019',
    thumbnailSource: 'collections/issues/2019/parts-cover/tinified/3-jas-2019-2-george_banu-pippo_delbono_Page_1.png',
    authorName: 'George Banu, Pippo Delbono',
    articleTitle: 'Conferință',
    filePath: 'collections/issues/2019/parts/3-jas-2019-2-george_banu-pippo_delbono.pdf'
  },
  {
    issueID: '2/2019',
    thumbnailSource: 'collections/issues/2019/parts-cover/tinified/4-jas-2019-2-george_banu-emmanuel_demarcy-mota_Page_01.png',
    authorName: 'George Banu, Emmanuel Demarcy-Mota',
    articleTitle: 'Conferință',
    filePath: 'collections/issues/2019/parts/4-jas-2019-2-george_banu-emmanuel_demarcy-mota.pdf'
  },
  {
    issueID: '2/2019',
    thumbnailSource: 'collections/issues/2019/parts-cover/tinified/5-jas-2019-2-jean_michel_ribes-matei_visniec_Page_01.png',
    authorName: 'Jean Michel Ribes, Matei Vișniec',
    articleTitle: 'Conferință',
    filePath: 'collections/issues/2019/parts/5-jas-2019-2-jean_michel_ribes-matei_visniec.pdf'
  },
  {
    issueID: '2/2019',
    thumbnailSource: 'collections/issues/2019/parts-cover/tinified/6-jas-2019-2-mariko_anazawa_Page_1.png',
    authorName: 'Mariko Anazawa',
    articleTitle: 'Le théâtre absurde au Japon. En attendant Godot au Japon',
    filePath: 'collections/issues/2019/parts/6-jas-2019-2-mariko_anazawa.pdf'
  },
  {
    issueID: '2/2019',
    thumbnailSource: 'collections/issues/2019/parts-cover/tinified/7-jas-2019-2-constantin_necula_Page_1.png',
    authorName: 'Constantin Necula',
    articleTitle: 'Horia Petra-Petrescu și Revista Teatrală (1913-1914). Artefacte ale gândirii teatrale românești în Ardeal',
    filePath: 'collections/issues/2019/parts/7-jas-2019-2-constantin_necula.pdf'
  },
  {
    issueID: '2/2019',
    thumbnailSource: 'collections/issues/2019/parts-cover/tinified/8-jas-2019-2-ofelia_popii_Page_1.png',
    authorName: 'Ofelia Popii',
    articleTitle: 'Spiritul ludic și actorul',
    filePath: 'collections/issues/2019/parts/8-jas-2019-2-ofelia_popii.pdf'
  },
  {
    issueID: '2/2019',
    thumbnailSource: 'collections/issues/2019/parts-cover/tinified/9-jas-2019-2-alba_stanciu_Page_1.png',
    authorName: 'Alba Stanciu',
    articleTitle: 'Raporturi stabile sau agresive între regie și stilul muzical',
    filePath: 'collections/issues/2019/parts/9-jas-2019-2-alba_stanciu.pdf'
  },
  {
    issueID: '2/2019',
    thumbnailSource: 'collections/issues/2019/parts-cover/tinified/10-jas-2019-2-alexandru_condurache_Page_1.png',
    authorName: 'Alexandru Condurache',
    articleTitle: 'Preambul la analiza limbajului filmic în opera lui Silviu Purcărete',
    filePath: 'collections/issues/2019/parts/10-jas-2019-2-alexandru_condurache.pdf'
  }
]

const publicationList = [
  {
    year: '1/2010',
    filePath: 'collections/issues/full/JRMC-2010-1.pdf'
  },
  {
    year: '1/2013',
    filePath: 'collections/issues/full/JRMC-2013-1.pdf'
  },
  {
    year: '1/2019',
    filePath: 'collections/issues/full/JRMC-2019-1.pdf'
  },
  {
    year: '1/2020',
    filePath: 'collections/issues/full/JRMC-2020-1.pdf'
  },
]

export { publications, publicationList }